module.exports = __webpack_public_path__ + "img/dinghan-logo.537d79fa.png";